// extracted by mini-css-extract-plugin
export default {"item_title":"subscript-item_item_title__McqxO","item_box":"subscript-item_item_box__LHvZj","date_span":"subscript-item_date_span__FER0C"};